import React, { useState } from 'react'

import { AnimatePresence, motion } from 'framer-motion'
import {
  Link as ReactRouterLink,
  useLocation,
  useOutlet,
} from 'react-router-dom'
import { Box, Link, Text } from '@chakra-ui/react'

export const SignInLayout: React.FC = () => {
  return (
    <Box className="min-h-screen flex flex-col px-2 sm:px-8 md:px-20 py-10 relative">
      <Box
        top={0}
        left={'50%'}
        transform={'translateX(-50%)'}
        my={10}
        position={'absolute'}
        className="flex items-center z-50 rounded-full bg-white"
      >
        <Text
          as={ReactRouterLink}
          to={'/home'}
          className={'rounded-full font-bold'}
          fontSize={'3xl'}
        >
          hirehire
        </Text>
      </Box>
      <Box className="flex flex-row gap-5 mt-24">
        <AnimatedBoxComponent />
      </Box>
      <Box className="flex gap-8 text-sm justify-center mt-10">
        <Link
          href="https://hirehire.ai/privacy-policy"
          isExternal
          className="text-gray-600 hover:text-gray-800"
        >
          Privacy Policy
        </Link>
        <Link
          href="https://hirehire.ai/terms-of-use"
          isExternal
          className="text-gray-600 hover:text-gray-800"
        >
          Terms of use
        </Link>
      </Box>
    </Box>
  )
}

const AnimatedBoxComponent = () => {
  const { pathname } = useLocation()

  return (
    <Box
      display={'flex'}
      maxWidth={'600px'}
      width={'full'}
      flexShrink={0}
      rounded={'40px'}
      p={{
        base: 6,
        md: 16,
      }}
      mx={{
        base: 'auto',
      }}
      zIndex={50}
      bgColor={'rgba(0, 0, 0, 0.05)'}
    >
      <AnimatePresence mode={'wait'}>
        <motion.div
          key={pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className={'flex mx-auto w-full'}
        >
          <AnimatedOutlet />
        </motion.div>
      </AnimatePresence>
    </Box>
  )
}

const AnimatedOutlet: React.FC = () => {
  const o = useOutlet()
  const [outlet] = useState(o)

  return <>{outlet}</>
}
